<div class="form-element">
  <div class="p-inputgroup" [class.has-options]="props.showOptions">
    <code-editor
      [class.multiline]="props.multiline"
      [style.height]="props.height"
      dndDropzone
      [formControl]="formControl"
      [languages]="props.languages || languages"
      [readonly]="props.readonly"
      [disabled]="props.disabled"
      [language]="props.language || 'json'"
      [setup]="props.setup || 'basic'"
      [placeholder]="props.placeholder"
      (change)="props.change?.(field, $event)"
      [extensions]="props.extension || extensions"
      (dndDrop)="onDrop($event)" />

    @if (props.showOptions && (props.options | observablePipe); as options) {
      <cap-dropdown
        dndDropzone
        [options]="options | formlySelectOptions: field | async"
        [formlyAttributes]="field"
        [formControl]="inputValueModel"
        (changeSelection)="onOptionChange($event)" />
    }
  </div>
</div>
